export default __webpack_public_path__ + "static/media/42c23bbdae31f9d559639e304cc637b8.svg";